import { inject, Pipe, PipeTransform } from '@angular/core';
import { Block, BlockType } from '../interfaces';
import { ContextModelService, QuestionFlowService } from '../services';

@Pipe({
    name: 'visibleQuestionBlocks',
    pure: false
})
export class VisibleQuestionBlocksPipe implements PipeTransform {
    private readonly service = inject(QuestionFlowService);
    private readonly contextModel = inject(ContextModelService);

    transform(blocks: Block[]): Block[] {
        return blocks.filter(
            (block: Block) =>
                block.blockType === BlockType.QuestionBlock &&
                !this.service.hiddenBlocks[block.id] &&
                !!block.template?.slots?.some(s => !Boolean(this.contextModel.processJsonLogic(s.isHidden!)))
        );
    }
}
